var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};
/* eslint-disable react/destructuring-assignment */


import React, { useState } from 'react';
import HeaderDesktop from './header-desktop';
import HeaderMobile from './header-mobile';

var Header = function Header(props) {
  var _a = __read(useState(null), 2),
      headerSubmenu = _a[0],
      setHeaderSubmenu = _a[1];

  var _b = __read(useState(false), 2),
      isMenuOpen = _b[0],
      setMenuOpen = _b[1];

  var _c = __read(useState(null), 2),
      mobileSubmenuId = _c[0],
      setMobileSubmenuId = _c[1];

  var state = {
    headerSubmenu: props.headerSubmenu || headerSubmenu,
    setHeaderSubmenu: props.setHeaderSubmenu || setHeaderSubmenu,
    isMenuOpen: props.isMenuOpen || isMenuOpen,
    setMenuOpen: props.setMenuOpen || setMenuOpen,
    mobileSubmenuId: props.mobileSubmenuId || mobileSubmenuId,
    setMobileSubmenuId: props.setMobileSubmenuId || setMobileSubmenuId
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderDesktop, __assign({}, props, state)), /*#__PURE__*/React.createElement(HeaderMobile, __assign({}, props, state)));
};

export default Header;